import Menu from '../components/Menu';
import Layout from '../components/layout/Layout';
import Seo from '../components/common/Seo';
import thaprachanMenu from '../data/thaprachanMenu';
import { CRAWLABLE_SECTIONS } from '../data/menuLookup';
import { BUSINESS_ID, SITE_URL, business } from '../data/business';

const MenuPage = () => {
  /**
   * Menu markup covers only the sections this page renders into the DOM on
   * load — the same list Menu.tsx keeps mounted. The remaining sections mount
   * only when their tab is clicked, so describing them here would be marking up
   * content a crawler never sees. No prices, because prices are not shown here.
   */
  const menuSchema = {
    '@context': 'https://schema.org',
    '@type': 'Restaurant',
    '@id': BUSINESS_ID,
    name: business.name,
    url: SITE_URL,
    hasMenu: {
      '@type': 'Menu',
      '@id': `${SITE_URL}/menu#menu`,
      name: 'Thaprachan Thai Cuisine menu',
      url: `${SITE_URL}/menu`,
      hasMenuSection: thaprachanMenu
        .filter((section) =>
          (CRAWLABLE_SECTIONS as readonly string[]).includes(section.title),
        )
        .map((section) => ({
          '@type': 'MenuSection',
          name: section.title,
          hasMenuItem: section.items.map((item) => ({
            '@type': 'MenuItem',
            name: item.name,
            ...(item.description ? { description: item.description } : {}),
          })),
        })),
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Menu', item: `${SITE_URL}/menu` },
    ],
  };

  return (
    <Layout>
      <Seo
        title="Thai Menu in Seattle | Thaprachan Thai Cuisine"
        description="The full Thaprachan Thai menu — noodles, curries, fried rice, salads, Thai street food and desserts — at 805 NE 65th St in north Seattle."
        path="/menu"
        schemas={[menuSchema, breadcrumbSchema]}
      />
      <Menu />
    </Layout>
  );
};

export default MenuPage;
